import { View } from "@/components/ui";
import { Typography } from "@/components/shared/typography";
import { User, PlusCircle } from "@/components/shared/icons";
import { ClientStatusReferralEnum } from "@/__generated__/graphql";
import { formatPrice } from "@/lib/helpers/number";
import { ReferralHistoryItem as ReferralHistoryItemType } from "./types";
import { cn } from "@/lib/utils";
import { getReferralTitle } from "./lib";

interface ReferralHistoryItemProps {
  item: ReferralHistoryItemType;
}

export const ReferralHistoryItem = ({ item }: ReferralHistoryItemProps) => {
  return (
    <View className="flex flex-row items-start gap-3 py-4">
      <View className="relative">
        <User
          size={24}
          weight="fill"
          className="text-foreground-intermediate"
        />
        <View className="absolute -bottom-0 -right-0 rounded-full bg-white p-px">
          <PlusCircle
            size={10}
            className={cn(
              "rounded-full",
              item.status === ClientStatusReferralEnum.Paid
                ? "text-success"
                : "text-warning",
            )}
            weight="fill"
          />
        </View>
      </View>
      <View className="mr-auto flex flex-col gap-1">
        <Typography variant="label-sm" color="foreground-default">
          {getReferralTitle(item.title, item.status)}
        </Typography>
        <Typography variant="body-sm" color="foreground-intermediate">
          {item.date}
        </Typography>
      </View>
      <Typography
        variant="body-lg"
        color={
          item.status === ClientStatusReferralEnum.Paid ? "success" : "warning"
        }
        className="self-center"
      >
        {item.amount > 0 ? "+" : ""}
        {formatPrice(item.amount)}
      </Typography>
    </View>
  );
};
